import {
  GET_ORDER_PENDING,
  GET_ORDER_SUCCESS,
  GET_ORDER_ERROR,
  POST_ORDER_PENDING,
  POST_ORDER_SUCCESS,
  POST_ORDER_ERROR,
  PUT_ORDER_PENDING,
  PUT_ORDER_SUCCESS,
  PUT_ORDER_ERROR,
  DELETE_ORDER_PENDING,
  DELETE_ORDER_SUCCESS,
  DELETE_ORDER_ERROR,
  CHECKOUT_ORDER_PENDING,
  CHECKOUT_ORDER_ERROR,
  CHECKOUT_ORDER_SUCCESS,
  SAVE_ORDER_PENDING,
  SAVE_ORDER_ERROR,
  SAVE_ORDER_SUCCESS,
  IMPORT_ORDER_PENDING,
  IMPORT_ORDER_SUCCESS,
  IMPORT_ORDER_ERROR,
  ORDER_DATA,
  SET_ORDER_DATA_MODAL,
} from "../../actions/order-data";

const initialState = {
  pending: false,
  error: null,
  data: null,
  detailData: null,
  isOpenModal: false,
  modalType: "",
  from: "",
  importData: null,
};

const order = (state = initialState, action) => {
  switch (action.type) {
    case GET_ORDER_PENDING:
      return {
        ...state,
        pending: true,
      };
    case GET_ORDER_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case GET_ORDER_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case POST_ORDER_PENDING:
      return {
        ...state,
        pending: true,
      };
    case POST_ORDER_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case POST_ORDER_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case PUT_ORDER_PENDING:
      return {
        ...state,
        pending: true,
      };
    case PUT_ORDER_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case PUT_ORDER_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case DELETE_ORDER_PENDING:
      return {
        ...state,
        pending: true,
      };
    case DELETE_ORDER_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case DELETE_ORDER_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case CHECKOUT_ORDER_PENDING:
      return {
        ...state,
        pending: true,
      };
    case CHECKOUT_ORDER_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case CHECKOUT_ORDER_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case SAVE_ORDER_PENDING:
      return {
        ...state,
        pending: true,
      };
    case SAVE_ORDER_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case SAVE_ORDER_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case IMPORT_ORDER_PENDING:
      return {
        ...state,
        pending: true,
      };
    case IMPORT_ORDER_SUCCESS:
      return {
        ...state,
        pending: false,
        importData: action.data,
        from: "IMPORT",
      };
    case IMPORT_ORDER_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case ORDER_DATA:
      return {
        ...state,
        detailData: action.data,
      };
    case SET_ORDER_DATA_MODAL:
      return {
        ...state,
        isOpenModal: action.data.isOpen,
        modalType: action.data.modalType,
      };
    default:
      return state;
  }
};

export default order;
